(function(angular){
	'use strict';
	
	angular
		.module('viewMarketModule')
		.controller('ViewMarket', [
			'$filter',
			'$scope',
			'globalConfig',
			'PropertyService',
			ViewMarketFunction
		]);
	
	function ViewMarketFunction(
		$filter,
		$scope,
		globalConfig,
		PropertyService
	){
		var viewMarket = this;

		viewMarket.properties = PropertyService.formatPropertyList(globalConfig.assets);

		if(globalConfig.featuredAssetOne) {
			viewMarket.featuredAssetOne = PropertyService.formatPropertyListItem(globalConfig.featuredAssetOne);
		}
		
		if(globalConfig.featuredAssetTwo) {
			viewMarket.featuredAssetTwo = PropertyService.formatPropertyListItem(globalConfig.featuredAssetTwo);
		}
	}
})(window.angular);